import React from 'react';
import { object, node } from 'prop-types';

export const FsmContext = React.createContext();

const FsmProvider = ({ machine, children }) => <FsmContext.Provider value={machine}>{children}</FsmContext.Provider>;

FsmProvider.propTypes = {
  machine: object.isRequired,
  children: node.isRequired,
};

export default FsmProvider;
